import React, { useContext } from 'react';
import { Row } from '../../../shared/utils';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { TokenContext } from '../../../../App';
import { DateTime } from 'luxon';
import OverrideRiskLevel from './OverrideRiskLevel';
import Modal from '../../../shared/Modal';
import CustomTooltip from '../CustomTooltip';
const SubmissionCard = ({
  getRiskTag,
  setFormData,
  formData,
  handleFileChange,
  getStatusTag,
  handleStatusUpdate,
  handleSaveForm,
  currentUrl,
  userRole,
  handleInputChange,
  allreviewers,
  handleSubmitForReview,
  readOnly,
  requireHigherRiskLevelPrompt,
  formDataLength,
  apiFailed = false,
  showOverrideRiskLevel = false,
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get('page');

  const [encodedAccessToken] = useContext(TokenContext);
  const decodedToken = jwtDecode(encodedAccessToken);
  userRole = decodedToken.role;

  const handleFileRemove = async fileName => {
    setFormData(prevState => ({
      ...prevState,
      [fileName]: '',
    }));
  };

  return (
    <div>
      {page == 2 && showOverrideRiskLevel && (
        <OverrideRiskLevel
          formData={formData}
          setFormData={setFormData}
          handleInputChange={handleInputChange}
          handleFileChange={handleFileChange}
          readOnly={readOnly}
          show={true}
        />
      )}

      {requireHigherRiskLevelPrompt && !formData.hasFilledEdd && (
        <div className='bg-red-50 p-3 border-2 border-red-100'>
          <p className='mb-2 font-semibold'> Enhanced Due Diligence </p> <hr />
          <Row>
            <div className='mb-4'>
              <p className='my-2 font-semibold'> Source of Wealth/Funds </p>
              {formData.sourceOfWealthDocumentURL && (
                <>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.sourceOfWealthDocumentURL.split('/').slice(-1)[0]}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600'
                  >
                    {decodeURIComponent(formData.sourceOfWealthDocumentURL.split('/').slice(-1)[0])}
                  </a>
                  <span className='cursor-pointer' onClick={() => handleFileRemove('sourceOfWealthDocumentURL')}>
                    {' '}
                    ❌{' '}
                  </span>
                </>
              )}

              <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
                Browse
                <input
                  maxLength={800}
                  type='file'
                  name='sourceOfWealthDocumentURL'
                  onChange={handleFileChange}
                  className='pt-3 hidden'
                />
              </label>
            </div>

            <div className='mb-4'>
              <p className='my-2 font-semibold'> Management Support </p>
              {formData.managementSupportDocumentURL && (
                <p>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.managementSupportDocumentURL.split('/').slice(-1)[0]}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600 my-2'
                  >
                    {decodeURIComponent(formData.managementSupportDocumentURL.split('/').slice(-1)[0])}
                  </a>
                  <span className='cursor-pointer' onClick={() => handleFileRemove('managementSupportDocumentURL')}>
                    {' '}
                    ❌{' '}
                  </span>
                </p>
              )}
              <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
                Browse
                <input
                  maxLength={800}
                  type='file'
                  name='managementSupportDocumentURL'
                  onChange={handleFileChange}
                  className='pt-3 hidden'
                />
              </label>
            </div>

            <div className='mb-4'>
              <p className='my-2 font-semibold'> Other Documents </p>
              {formData.otherDocumentsURL && (
                <p>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.otherDocumentsURL.split('/').slice(-1)[0]}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600 my-2'
                  >
                    {/* <a href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.otherDocumentsURL.split('/').slice(-1)[0]}&accessToken=${token}`} target='_blank'  rel="noopener noreferrer"  className='text-blue-600 my-2'>  */}
                    {decodeURIComponent(formData.otherDocumentsURL.split('/').slice(-1)[0])}
                  </a>
                  <span className='cursor-pointer' onClick={() => handleFileRemove('otherDocumentsURL')}>
                    {' '}
                    ❌{' '}
                  </span>
                </p>
              )}
              <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
                Browse
                <input
                  maxLength={800}
                  type='file'
                  name='otherDocumentsURL'
                  onChange={handleFileChange}
                  className='pt-3 hidden'
                />
              </label>
            </div>
          </Row>
          {
            <div className='mt-4'>
              <p className='my-2 font-semibold'>Nature of enhanced ongoing monitoring of the business relationship</p>
              <textarea
                name='enhancedOngoingMonitoringRelationship'
                placeholder='Enter Nature of enhanced ongoing monitoring of the business relationship'
                value={formData.enhancedOngoingMonitoringRelationship || ''}
                onChange={handleInputChange}
                className='w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-green-500'
                rows={3}
              />
            </div>
          }
        </div>
      )}

      {formData?.status == 'rejected' && (
        <p className='my-5 mt-7'>
          {' '}
          Rejected at:{' '}
          <span className='bg-gray-200 py-2 px-4 border border-b-gray-300 '> {formData.screenedDate} </span>{' '}
        </p>
      )}

      {/* {formData?.status == 'accepted' && (  */}
      <div>
        {page != 3 && (
          <p className='my-5 mt-7'>
            {' '}
            Accepted at:{' '}
            <span className='bg-gray-200 py-2 px-4 border border-b-gray-300 '> {formData.approvalDate} </span>{' '}
          </p>
        )}

        {page == 3 && (
          <p className='my-5 mt-7'>
            Client Approved Date:
            <span className='bg-gray-200 py-2 px-4 border border-b-gray-300'>
              {formData.createDate && DateTime.fromFormat(formData.createDate, 'dd-MM-yyyy, HH:mm:ss').isValid
                ? DateTime.fromFormat(formData.createDate, 'dd-MM-yyyy, HH:mm:ss', { zone: 'Asia/Singapore' }).toFormat(
                    'dd-MM-yyyy'
                  )
                : 'N/A'}
            </span>
          </p>
        )}
        <p className='my-5 mt-7'>
          {' '}
          <span className='mr-2'>Next Assessment Date:</span>
          <Modal
            title='Definitions'
            token={encodedAccessToken}
            className='inline'
            CustomButton={() => <CustomTooltip title='Click to View definition/guidance' />}
          >
            <NextAssessmentDateDefinition />
          </Modal>
          <span className='bg-gray-200 py-2 px-4 border border-b-gray-300 ml-2'>
            {formData?.nextRescreeningDate ? (
              <>
                {formData.nextRescreeningDate.split('-')[0]}-{formData.nextRescreeningDate.split('-')[1]}-
                <span className='text-purple-600'>{formData.nextRescreeningDate.split('-')[2]}</span>
              </>
            ) : (
              'N/A'
            )}
          </span>
          {page != 3 && formData?.status == 'accepted' && (
            <button
              onClick={() => {
                window.location = window.location.href.replace('page=2', 'page=3');
              }}
              className='ml-5 bg-green-500 hover:bg-green-600 text-white py-2 px-4 mr-5'
            >
              To Ongoing Monitoring
            </button>
          )}
        </p>
      </div>
      {/* )} */}

      {page == 2 ? (
        <p className='my-5'>
          {' '}
          Acceptance Status: <span className='text-red-500'> {getStatusTag(formData.status)} </span>{' '}
        </p>
      ) : (
        <span className='my-5'>
          {' '}
          Review Status: <span className='text-red-500'> {getStatusTag(formData.status)} </span>{' '}
        </span>
      )}

      {page != 3 &&
        formData?.status &&
        (formData.status === 'waiting for review' || formData.status === 'rejected') &&
        formData.status !== 'accepted' &&
        userRole !== 'preparer' &&
        userRole !== 'viewer' && (
          <Row>
            {!readOnly && (
              <>
                <div className='mb-6'>
                  <button
                    className={`bg-green-500 text-white py-2 px-4 mr-5 ${apiFailed ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-600'}`}
                    onClick={e => handleStatusUpdate(e, 'accepted')}
                    disabled={apiFailed}
                  >
                    Accept
                  </button>
                  <button
                    className={`bg-red-500 text-white py-2 px-4 ${apiFailed ? 'opacity-50 cursor-not-allowed' : 'hover:bg-red-600'}`}
                    onClick={e => {
                      handleStatusUpdate(e, 'rejected');
                    }}
                    disabled={apiFailed}
                  >
                    Reject
                  </button>
                </div>
              </>
            )}
          </Row>
        )}
      {page == 3 &&
        formData?.status &&
        currentUrl !== '/form/kyc-aml' &&
        userRole !== 'preparer' &&
        userRole !== 'viewer' && (
          <Row>
            {!readOnly && (
              <>
                <div className='mb-6'>
                  <button
                    disabled={formData?.reviewStatus == 'Reviewed'}
                    className={`${formData?.reviewStatus == 'Reviewed' || formData?.status == 'accepted' ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'} mr-5 text-white py-2 px-4`}
                    onClick={e => {
                      if (formData?.reviewStatus == 'Reviewed' || formData?.status == 'accepted') {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                      }
                      handleStatusUpdate(e, 'review');
                    }}
                  >
                    Review
                  </button>
                  <button
                    disabled={formData?.reviewStatus == 'Reviewed' || formData?.reviewStatus == 'autoReviewed'}
                    className={`${formData?.reviewStatus == 'Reviewed' || formData?.status == 'accepted' ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600'} text-white py-2 px-4`}
                    onClick={e => {
                      if (formData?.reviewStatus == 'Reviewed' || formData?.status == 'accepted') {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                      }
                      handleStatusUpdate(e, 'sendBack');
                    }}
                  >
                    Send Back
                  </button>
                </div>
              </>
            )}
          </Row>
        )}
      {formData?.status !== 'accepted' && currentUrl !== '/form/kyc-aml' && userRole !== 'viewer' && !readOnly && (
        <>
          <Row>
            <div>
              <select
                value={formData?.reviewerReviewEmail}
                onChange={handleInputChange}
                name='reviewerReviewEmail'
                className='p-1.5  mr-2 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none mb-3 focus:border-green-500'
              >
                <option> - Do not send Email - </option>
                {allreviewers.map((reviewer, index) => (
                  <option key={index} value={reviewer.email}>
                    {' '}
                    {reviewer.name} - {reviewer.email}{' '}
                  </option> // when using .map, NEED ( after arrow => ( which is a 'return statement'
                ))}
              </select>
              <button
                disabled={formData?.reviewStatus == 'Reviewed'}
                className={`${formData?.reviewStatus == 'Reviewed' ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'} text-white py-2 px-4 mr-1`}
                onClick={e => {
                  if (formData?.reviewStatus == 'Reviewed') {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                  }
                  handleSubmitForReview(e);
                }}
              >
                Submit for Review
              </button>
              <Tooltip
                title={
                  <p>
                    {' '}
                    This sends an email with the current url to the reviewer selected for them to review this risk
                    assessment.
                  </p>
                }
                arrow
                componentsProps={{
                  tooltip: {
                    sx: { maxWidth: '445px', fontSize: '14px' },
                  },
                }}
              >
                <span className='text-xl relative bottom-0.5'> ⓘ </span>
              </Tooltip>
            </div>
            <button className='bg-green-500 hover:bg-green-600 text-white py-2 px-4 mr-5' onClick={handleSaveForm}>
              {' '}
              Save{' '}
            </button>
          </Row>
        </>
      )}

      <Row className='mb-4 justify-end'>
        <div>
          {' '}
          Submitted by: {formData.submitPerson} {formData.submitPerson && 'on'} {formData.submitDate}{' '}
        </div>
        <div>
          {' '}
          Reviewed by: {formData.approvalPerson} {formData.approvalPerson && 'on'} {formData.approvalDate}{' '}
        </div>
      </Row>
    </div>
  );
};

const NextReviewDateDefinition = () => {
  return (
    <div className='p-6 w-6xl'>
      <p>
        <strong>Next Review Date:</strong>
      </p>
      <ul className='list-disc pl-6 mt-2'>
        <li>
          Refers to the frequency of reviewing alerts triggered during ongoing monitoring (which runs daily). Any new
          hits identified within this 3-month period must be reviewed and cleared. Unresolved hits will be logged and
          carried forward to the next review cycle for your follow-up.
        </li>
      </ul>
    </div>
  );
};

const NextAssessmentDateDefinition = () => {
  return (
    <div className='p-6 w-6xl'>
      <p>
        <strong>Next Assessment Date:</strong>
      </p>
      <ul className='list-disc pl-6 mt-2'>
        <li>
          Refers to the frequency of performing a full KYC refresh and risk reassessment of the case. The default
          assessment interval varies based on the assigned risk level (e.g., low, medium, high).
        </li>
      </ul>
    </div>
  );
};

export default SubmissionCard;
